var React = require('react');

function BtnFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM17.5944 12.4761H21L20.6102 16.0075H17.5944V26H13.1249V16.0075H11V12.4761H13.1249V10.1917C13.1249 8.55599 13.9611 6 17.6353 6L20.9452 6.01201V9.43904H18.5419C18.1503 9.43904 17.5944 9.62078 17.5944 10.4003V12.4761Z","fill":"#AAAAAA"}));
}

BtnFacebook.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = BtnFacebook;

BtnFacebook.default = BtnFacebook;
